import React, { useState, useEffect } from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import { getAuth } from 'firebase/auth';
import { firebaseConfig, db } from './firebase';
import { Link } from 'react-router-dom';
import AddTaskPopup from './AddTaskPopup';

firebase.initializeApp(firebaseConfig);

const AddTask = () => {
    const auth = getAuth();
    const [tasks, setTasks] = useState([]);
    const [firebaseUserInfo, setFirebaseUserInfo] = useState(null);

    const AddingTaskFB = (task) => {
        setTasks(prevTasks => [...prevTasks, task]);
    };

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            setFirebaseUserInfo(user);
        });
        
        return () => unsubscribe();
    }, [auth]);
    
    useEffect(() => {
        const fetchTasks = async () => {
          try {
            const auth = getAuth();
            const user = auth.currentUser;
            let tasks = [];
            
            if (user) {
              const snapshot = await db.collection('tasks')
                .where('deleted', '==', false)
                .where('userId', '==', user.uid)
                .get();
              tasks = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
            } else {
              const storedTasks = sessionStorage.getItem('tasks');
              if (storedTasks) {
                tasks = JSON.parse(storedTasks);
              }
            }
            
            setTasks(tasks);
          } catch (error) {
            console.error(error);
          }
        };
        
        fetchTasks();
      }, [db, firebaseUserInfo]);
      

        //Toggle the Complete Checkbox
        const toggleComplete = async (index) => {
            const updatedTasks = [...tasks];
            updatedTasks[index].completed = !updatedTasks[index].completed;
          
            const auth = getAuth();
            const user = auth.currentUser;
            if (user) {
              try {
                await db.collection('tasks').doc(updatedTasks[index].id).update({ completed: updatedTasks[index].completed });
                console.log('Task Complete:', updatedTasks[index].id);
              } catch (error) {
                console.error('Error Marking Task:', error);
              }
            } else {
              sessionStorage.setItem('tasks', JSON.stringify(updatedTasks));
            }
            setTasks(updatedTasks);
          };
          

    return (
        <div className="task-container">
            <div className="session-1">
            <table className='taskHPtable'>
                <thead>
                    <tr className='taskHP'>
                        <th> Session 1</th>
                        <th> Completed?</th>
                    </tr>
                </thead>
                <tbody>
                {tasks.map((task, index) => (
                    <tr key={index} className='taskHP'>
                        <td>• {task.name}</td> 
                        <td className='checked'>
                            <input
                            type="checkbox"
                            checked={task.completed}
                            onChange={() => toggleComplete(index)}
                            />
                        </td>
                    </tr>
                ))} 
                </tbody>        
            </table>
        </div>
            <div className="view-all">
                <Link to="/taskbar"><button>View all</button></Link>
            </div>
            <div className='plus'>
                <AddTaskPopup addTask={AddingTaskFB} /> 
            </div>
        </div>

    )
};

export default AddTask;